module.exports = __webpack_public_path__ + "img/metal-scales.bed9d927.svg";